<template>
  <div>
    <h2>Общая информация</h2>
    <b-list-group>
      <b-list-group-item variant="secondary">Минимальная длительность сеанса связи составляет 1 сек., дальнейшее приращение длительности сеанса связи осуществляется временными интервалами по 1 сек. </b-list-group-item>
      <b-list-group-item variant="secondary">При тарификации используются исключительно статистические данные Исполнителя. </b-list-group-item>
      <b-list-group-item variant="secondary">После завершения сеанса связи с лицевого счета Заказчика списывается фактическая стоимость сеанса связи, равная длительности сеанса связи в минутах, 
    умноженной на цену Направления.</b-list-group-item>
      <b-list-group-item variant="secondary">Началом сеанса связи считается момент получения подтверждения на SIP-сообщение ACK .</b-list-group-item>
      <b-list-group-item variant="secondary">Стоимость остальных услуг оказываемых Исполнителем заказчику списывается с лицевого счета в начале учетного периода действия услуги. </b-list-group-item>
    </b-list-group>
    <br>
    <h2>Цены по основным направлениям(В рамках договора ИП "Майоров")</h2>
    <b-table striped hover  :items="getItemsList" :fields="fields" ></b-table>
  </div>
</template>

<script>
import axios from "axios";

export default {
  name: "tarifs",
  data() {
    return {
      fields: [
        {
          key: "regex",
          label: "Номер(шаблон)",
          sortable: true
        },
        {
          key: "destination",
          label: "Направление",
          sortable: true
        },
        {
          key: "cost",
          label: "Цена, руб(без НДС)",
          sortable: true
        }
      ],
      //  items: [
      //    {dir: '88634',name:'Таганрог',cost:0.40},
      //    {dir:'8863[0-2]',name:'Ростов-на-Дону',cost:0.60},
      //    {dir: '8863',name:'Ростовская область',cost:0.9},
      //    {dir: '89', name:'Россия, мобильные',cost:1.80}
      //  ]

      items: []
      //axios.get('http://127.0.0.1:3000/service/tariflist')
    };
  },
  methods: {
    getItemsList(ctx) {
      // Here we don't set isBusy prop, so busy state will be handled by table itself

      console.log(ctx);
      this.isBusy = true;
      if (this.items.length > 0) {
        // Значит уже данные получены. Обработка сортировок.
        if (ctx.sortBy) {
          // Реализация сортировки.
          if (ctx.sortBy == "regex") {
            // Сортируем направления
            this.items.sort(compareRegex);
            if (!ctx.sortDesc) {
              // Инверсия сортировки
              this.items.reverse();
            }
          }
          if (ctx.sortBy == "destination") {
            // Сортируем по назначению.
            this.items.sort(compareDest);
            if (!ctx.sortDesc) {
              // Инверсия сортировки
              this.items.reverse();
            }
          }
          if (ctx.sortBy == "cost") {
            // Сортируем по назначению.
            this.items.sort(compareCost);
            if (!ctx.sortDesc) {
              // Инверсия сортировки
              this.items.reverse();
              console.log("reverse!");
            }
          }
        }
        return this.items;
      }
      let promise = axios({
        method: "get",
        url: "http://sip.tagan.ru:3000/service/tariflist",
        headers: {
          "Access-Control-Allow-Origin": "*",
          token:
            "zeij1aj5ieruixo6oowovidfowrsrmfk8oofioj9eith5Thee7aeQuuosexuanohs"
        }
      });

      return promise
        .then(data => {
          const items = data.data.data;
          // Here we could override the busy state, setting isBusy to false
          this.isBusy = true;
          console.log(this.items);
          console.log(items);
          this.items = items;
          return items;
        })
        .catch(error => {
          // Here we could override the busy state, setting isBusy to false
          this.isBusy = false;
          // Returning an empty array, allows table to correctly handle busy state in case of error
          return [];
        });
    }
  }
};
function compareCost(a, b) {
  return a.cost - b.cost;
}
function compareRegex(a, b) {
  if (a.regex > b.regex) return 1;
  if (a.regex < b.regex) return -1;
}
function compareDest(a, b) {
  if (a.destination > b.destination) return 1;
  if (a.destination < b.destination) return -1;
}
// not usable
// function myProvider() {
//   axios({
//   method:'get',
//   url:'http://10.55.48.207:3000/service/tariflist',
//   headers: {'Access-Control-Allow-Origin': '*',
//            'token': 'zeij1aj5ieruixo6oowovidfowrsrmfk8oofioj9eith5Thee7aeQuuosexuanohs'
//   }
// }).then(function(res) {
//     return res.data.data;
// });
// }
</script>




// WEBPACK FOOTER //
// src/Tarifs.vue